$( ->
  # APPS > SEND OFFER > CHOOSE OFFER LETTER TEMPLATE MODAL

  ## Gets correct template according to modal selection

  $(document).on 'change', 'form#new_offer_letter select#offer_letter_offer_letter_template_id', ->
    url = $('form#new_offer_letter').attr('action')
    url = url.replace(/\.js$/, "/new.js?offer_letter_template_id=#{$(this).val()}")
    $.get url

)
